import React from 'react';
import Button from 'kepler/lib/components/Button';
import getContent from '../lib/dictionaryFetcher';
import PropTypes from 'prop-types';

const ViewAllButton = ({ subcategoryIndex, changeTab }) => {
  const triggerViewAll = () => {
    changeTab(subcategoryIndex);
    window.scrollTo(0, 0);
  };

  return (
    <Button type="link-text" onClick={triggerViewAll}>
      {getContent('merchanthub', `discover.viewall`, '')}
    </Button>
  );
};

ViewAllButton.propTypes = {
  subcategoryIndex: PropTypes.string,
  changeTab: PropTypes.func
};

export default ViewAllButton;
